import React from "react";
import { Text, View, Image } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";

const PrintSection7 = ({ section7 }) => {
  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 7 – Fitness and Propriety
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        If you answer 'Yes' to any of the questions in this section, please
        provide all details in the Additional Information page at the back of
        the application
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        7.01 Criminal Proceedings
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        When answering the questions in this section you should include matters
        whether in the UK or overseas. By virtue of the Rehabilitation of
        Offenders Act 1974 (Exceptions) Order 1975, you are the subject to the
        law of England and Wales, you must disclose spent convictions and
        cautions (other than a protected conviction or caution). In the
        following questions, you should include all matters even when the
        arrest, charge, prosecution or investigation did not result in a
        conviction, and in respect of 7.01.4, even where you were not the
        subject of the investigation.
      </Text>

      <Text style={PrintApplicationStyles.subcontent}>7.01.1</Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a. Have you ever been convicted on any criminal offence? (whether
              spent or not and whether or not in the United Kingdom)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.criminalOffence === true
                  ? "Yes"
                  : section7?.criminalOffence === false
                    ? "No"
                    : section7?.criminalOffence === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              i. Involving fraud, theft, false accounting, offences against the
              administration of public justice (such as perjury, perverting the
              course of justice and intimidation of witness or jurors), serious
              tax offences or other dishonesty
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.criminalOffenceRelatedToFraud === true
                  ? "Yes"
                  : section7?.criminalOffenceRelatedToFraud === false
                    ? "No"
                    : section7?.criminalOffenceRelatedToFraud === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              ii. Relating to companies, building societies, industrial and
              provident societies, credit unions, friendly societies, insurance,
              banking or other financial services, insolvency, consumer credit
              or consumer protection, money laundering, market manipulations or
              insider dealing?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.criminalOffenceRelatedToCompanies === true
                  ? "Yes"
                  : section7?.criminalOffenceRelatedToCompanies === false
                    ? "No"
                    : section7?.criminalOffenceRelatedToCompanies === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b. Are you or have you ever been, the subject of any criminal
              proceedings, where in the UK or elsewhere?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.criminalProceedings === true
                  ? "Yes"
                  : section7?.criminalProceedings === false
                    ? "No"
                    : section7?.criminalProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              c. Have you ever been given a caution in relation to any criminal
              offence?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.subjectToCriminalOffence === true
                  ? "Yes"
                  : section7?.subjectToCriminalOffence === false
                    ? "No"
                    : section7?.subjectToCriminalOffence === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.01.4 Have you ever been ordered to produce documents pursuant
              to any criminal investigation or been subject of a search (with
              or without a warrant) pursuant to any criminal investigation?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.produceDocuments === true
                  ? "Yes"
                  : section7?.produceDocuments === false
                    ? "No"
                    : section7?.produceDocuments === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.01.5 Has any firm at which you held a position of influence
              ever:
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              i. Been convicted of any criminal offence?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.firmConvictedOfCriminalOffence === true
                  ? "Yes"
                  : section7?.firmConvictedOfCriminalOffence === false
                    ? "No"
                    : section7?.firmConvictedOfCriminalOffence === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              ii. Been summonsed, charged with or otherwise investigated or
              prosecuted for any criminal offence?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.firmSummonedChargedInvestigated === true
                  ? "Yes"
                  : section7?.firmSummonedChargedInvestigated === false
                    ? "No"
                    : section7?.firmSummonedChargedInvestigated === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              iii. Been the subject of any criminal proceeding which has not
              resulted in a conviction?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.firmSubjectOfCriminalProceedings === true
                  ? "Yes"
                  : section7?.firmSubjectOfCriminalProceedings === false
                    ? "No"
                    : section7?.firmSubjectOfCriminalProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              iv. Been ordered to produce documents in relation to any criminal
              investigation or been the subject of a search (with or without a
              warrant) in relation to any criminal investigation?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.firmOrderedToProduceDocuments === true
                  ? "Yes"
                  : section7?.firmOrderedToProduceDocuments === false
                    ? "No"
                    : section7?.firmOrderedToProduceDocuments === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.01.2 Do you have any convictions for any offences other than
              those above (excluding traffic offences that did not result in a
              ban from driving or did not involve driving without insurance)?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.otherConvictions === true
                  ? "Yes"
                  : section7?.otherConvictions === false
                    ? "No"
                    : section7?.otherConvictions === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.01.3 Have you ever been arrested or charged with any criminal
              offence or been the subject of any criminal investigation?
              (Youshould include all matters even if the arrest, charge or
              investigation did not result in a conviction)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.arrestedForCriminalOffence === true
                  ? "Yes"
                  : section7?.arrestedForCriminalOffence === false
                    ? "No"
                    : section7?.arrestedForCriminalOffence === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Additional Information (7.01)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.additionalInformation_7_01 || ""}</Text>
            </View>
          </View>
        </View>
      </View>

      <Text style={PrintApplicationStyles.subcontent}>
        7.02 Civil Proceedings
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.1 Have you ever been the subject of a judgement debt or aware
              against you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.judgementDebt === true
                  ? "Yes"
                  : section7?.judgementDebt === false
                    ? "No"
                    : section7?.judgementDebt === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.2 Have you ever been party to any civil proceedings which
              resulted in any order against you (other than a judgement debt or
              award reffered to in 7.02.1 above)?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.partyToCivilProceedings === true
                  ? "Yes"
                  : section7?.partyToCivilProceedings === false
                    ? "No"
                    : section7?.partyToCivilProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.3 Are you aware of:
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              i. Any proceedings that have begun, or anyone’s intention to
              begin proceedings against you, for a CCJ or another judgement
              debt?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.awareOfProceedingsAganistYou === true
                  ? "Yes"
                  : section7?.awareOfProceedingsAganistYou === false
                    ? "No"
                    : section7?.awareOfProceedingsAganistYou === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              ii. More than one set of proceedings, or anyone’s intention to
              begin more than one set of proceedings, that may lead to a CCJ or
              other judgement debt?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.moreThanOneSetOfProceedings === true
                  ? "Yes"
                  : section7?.moreThanOneSetOfProceedings === false
                    ? "No"
                    : section7?.moreThanOneSetOfProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              iii. Anyone’s intention to claim more than £1,000 of CCJs or
              judgement debts in total from you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.claimDebtFromYou === true
                  ? "Yes"
                  : section7?.claimDebtFromYou === false
                    ? "No"
                    : section7?.claimDebtFromYou === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.4 Do you have any current judgement debts (including CCJs)
              made under a court order still outstanding, whether in full or in
              part?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.currentJudgementDebt === true
                  ? "Yes"
                  : section7?.currentJudgementDebt === false
                    ? "No"
                    : section7?.currentJudgementDebt === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.5 Have you ever failed to satisfy any such judgement debts
              (including CCJs) made under a court order still outstanding,
              whether in full or part, within one year of the order being made?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.failedToSatisfyJudgementDebt === true
                  ? "Yes"
                  : section7?.failedToSatisfyJudgementDebt === false
                    ? "No"
                    : section7?.failedToSatisfyJudgementDebt === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.6 Have you ever?
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a. Filed for your own bankruptcy or had a bankruptcy petition
              served on you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.filedForBankruptcy === true
                  ? "Yes"
                  : section7?.filedForBankruptcy === false
                    ? "No"
                    : section7?.filedForBankruptcy === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b. Been adjudged bankrupt?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.adjudgedBankrupt === true
                  ? "Yes"
                  : section7?.adjudgedBankrupt === false
                    ? "No"
                    : section7?.adjudgedBankrupt === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              c. Been the subject of a bankruptcy restrictions order (including
              an interim bankruptcy restriction order) or offered a bankruptcy
              restriction undertaking?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.subjectOfBankruptcyRestrictions === true
                  ? "Yes"
                  : section7?.subjectOfBankruptcyRestrictions === false
                    ? "No"
                    : section7?.subjectOfBankruptcyRestrictions === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              d. Made any arrangements with your creditors, for example, a deed
              of arrangement or an individual voluntary arrangement (or in
              Scotland a trust deed)?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.arrangementsWithCreditors === true
                  ? "Yes"
                  : section7?.arrangementsWithCreditors === false
                    ? "No"
                    : section7?.arrangementsWithCreditors === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              e. Had assets sequestrated?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.assetsSequestrated === true
                  ? "Yes"
                  : section7?.assetsSequestrated === false
                    ? "No"
                    : section7?.assetsSequestrated === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              f. Been involved in any proceedings relating to the above matters
              even if such proceedings did not result in the making of any kind
              of order or results in any kind of agreement with you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.involvedInProceedings === true
                  ? "Yes"
                  : section7?.involvedInProceedings === false
                    ? "No"
                    : section7?.involvedInProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.7 Do you, or any undertaking under their management, have
              any outstanding financial obligations arising from regulated
              activities, which have been carried out in the past? (whether or
              not in the UK or overseas)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.financialObligations === true
                  ? "Yes"
                  : section7?.financialObligations === false
                    ? "No"
                    : section7?.financialObligations === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.8 Have you ever been adjudged by a court or tribunal
              (whether criminal, civil or administrative) for any fraud,
              misfeasance, negligence, wrongful trading or other misconduct?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.courtAdjudgedForMisconduct === true
                  ? "Yes"
                  : section7?.courtAdjudgedForMisconduct === false
                    ? "No"
                    : section7?.courtAdjudgedForMisconduct === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.9 Are you currently?
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) Party to any civil proceedings? (including those covered in
              7.02.2 above)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.currentlyPartyToCivilProceedings === true
                  ? "Yes"
                  : section7?.currentlyPartyToCivilProceedings === false
                    ? "No"
                    : section7?.currentlyPartyToCivilProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b) Aware of anybody’s intention to begin civil proceedings against
              you? (you should include any ongoing disputes whether or not such
              dispute is likely to results in any order against you.)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.awareOfCivilProceedings === true
                  ? "Yes"
                  : section7?.awareOfCivilProceedings === false
                    ? "No"
                    : section7?.awareOfCivilProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.10
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Has any firm at which you hold or have held a position of
              influence ever been:
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) Adjudged by a court civilly liable for any fraud, misfeasance,
              wrongful trading or other misconduct?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.firmAdjudgedByCourt === true
                  ? "Yes"
                  : section7?.firmAdjudgedByCourt === false
                    ? "No"
                    : section7?.firmAdjudgedByCourt === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b) The subject of a judgement debt or award against the firm?
              (you should include all CCJs) made against the firm, whether
              satisfied or not.
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.judgementDebtAganistFirm === true
                  ? "Yes"
                  : section7?.judgementDebtAganistFirm === false
                    ? "No"
                    : section7?.judgementDebtAganistFirm === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              c) Party to any civil proceedings which resulted in an order
              against the firm other than in relation to matters covered in
              7.02.10a and 7.02.10b above?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.partyToCivilProceedingsAganistFirm === true
                  ? "Yes"
                  : section7?.partyToCivilProceedingsAganistFirm === false
                    ? "No"
                    : section7?.partyToCivilProceedingsAganistFirm === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.11
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Is any firm at which you currently hold or have held, within the
              last 12 months from the date of submission of this firm, a
              position of influence currently:
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) A part to civil proceedings?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.firmPartOfcivilProceedings === true
                  ? "Yes"
                  : section7?.firmPartOfcivilProceedings === false
                    ? "No"
                    : section7?.firmPartOfcivilProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b) Aware of anyone’s intention to begin civil proceedings against
              them?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.firmPartyToCivilProceedings === true
                  ? "Yes"
                  : section7?.firmPartyToCivilProceedings === false
                    ? "No"
                    : section7?.firmPartyToCivilProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.02.12 Have you been concerned in the management of a firm that
              has been put into liquidation (or been dissolved), wound up,
              ceased trading or been subject to an administration order, while
              you were connected with the firm or within one year of that
              connection?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.woundUpFirm === true
                  ? "Yes"
                  : section7?.woundUpFirm === false
                    ? "No"
                    : section7?.woundUpFirm === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Additional Information (7.02)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.additionalInformation_7_02 || ""}</Text>
            </View>
          </View>
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        7.03 Business and Employment Matters
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.03.1 Have you ever been:
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) Disqualified from acting as a director or similar position (one
              where you act in a management capacity or conducts the affairs or
              any company, partnership or unincorporated association)?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.disqualifiedFromDirector === true
                  ? "Yes"
                  : section7?.disqualifiedFromDirector === false
                    ? "No"
                    : section7?.disqualifiedFromDirector === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b) The subject of any proceedings of a disciplinary nature
              (whether or not the proceedings resulted in any findings against
              you)?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.subjectToProceedings === true
                  ? "Yes"
                  : section7?.subjectToProceedings === false
                    ? "No"
                    : section7?.subjectToProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              c) The subject of any investigation which has led or might lead
              to disciplinary proceedings?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.subjectToInvestigation === true
                  ? "Yes"
                  : section7?.subjectToInvestigation === false
                    ? "No"
                    : section7?.subjectToInvestigation === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              d) Notified of any potential proceedings of a disciplinary nature
              against you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.notifiedOfProceedings === true
                  ? "Yes"
                  : section7?.notifiedOfProceedings === false
                    ? "No"
                    : section7?.notifiedOfProceedings === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              e) The subject of an investigation into allegations of misconduct
              or malpractice in connection with any business activity (covering
              internal investigation by an authorised firm, as well as
              investigation by a regulatory body, at any time)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.subjectOfInvestigationWithBusinessActivity === true
                  ? "Yes"
                  : section7?.subjectOfInvestigationWithBusinessActivity ===
                      false
                    ? "No"
                    : section7?.subjectOfInvestigationWithBusinessActivity ===
                        "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.03.2 Have you ever been refused entry to, or been dismissed,
              suspended or requested to resign from, any professional,
              vocation, office or employment, or from any fiduciary office or
              position of trust whether or not remunerated?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.refusedEntry === true
                  ? "Yes"
                  : section7?.refusedEntry === false
                    ? "No"
                    : section7?.refusedEntry === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.03.3 Do you have any material written complaints made against
              you by your clients or former clients in the last five years
              which you have accepted, or which are awaiting determination, or
              have been upheld – by an ombudsman or complaints scheme?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.complaintsAgainstYou === true
                  ? "Yes"
                  : section7?.complaintsAgainstYou === false
                    ? "No"
                    : section7?.complaintsAgainstYou === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.03.4 Have you ever participated in an arbitration board?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.arbitrationBoard === true
                  ? "Yes"
                  : section7?.arbitrationBoard === false
                    ? "No"
                    : section7?.arbitrationBoard === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Additional Information (7.03)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.additionalInformation_7_03 || ""}</Text>
            </View>
          </View>
        </View>
      </View>

      <Text style={PrintApplicationStyles.subcontent}>
        7.04 Regulatory Matters
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.04.1 In relation to activities regulated by the FCA and/or PRA
              or any other regulatory body have:
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>• You, or</Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              • Any company, partnership or unincorporated associate of which
              you are or have been a controller, director, senior manager,
              partner or company secretary, during the candidate's association
              with the entity and for a period of three years after you ceased
              to be associated with it ever.....
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) Been refused, had revoked, restricted, been suspended from or
              any other permission granted by any such body?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.suspendedByRegulatoryBody === true
                  ? "Yes"
                  : section7?.suspendedByRegulatoryBody === false
                    ? "No"
                    : section7?.suspendedByRegulatoryBody === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b) Been criticized, censured, disciplined, suspended, expelled,
              fined or been the subject of any other disciplinary or
              interventional action by any such body?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.subjectOfDisciplinaryAction === true
                  ? "Yes"
                  : section7?.subjectOfDisciplinaryAction === false
                    ? "No"
                    : section7?.subjectOfDisciplinaryAction === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              c) Received a warning (public or private) that such permission
              or intentional action may be taken against you or the firm?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.receivedWarning === true
                  ? "Yes"
                  : section7?.receivedWarning === false
                    ? "No"
                    : section7?.receivedWarning === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              d) Been the subject of an investigation by any regulatory body,
              whether or not such an investigation resulted in a finding
              against you or the firm?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.subjectOfInvestigationByRegulatoryBody === true
                  ? "Yes"
                  : section7?.subjectOfInvestigationByRegulatoryBody === false
                    ? "No"
                    : section7?.subjectOfInvestigationByRegulatoryBody === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              e) Been required or requested to produce documents or any other
              information to any regulatory body in connection with such an
              investigation (whether against the firm or otherwise)?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.requiredToProduceDocuments === true
                  ? "Yes"
                  : section7?.requiredToProduceDocuments === false
                    ? "No"
                    : section7?.requiredToProduceDocuments === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              f) Been investigated or been involved in an investigation by an
              inspector appointed under companies or any other legislation, or
              required to produce documents to the Secretary of State, or any
              other authority, under any such legislation?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.investigationByInspector === true
                  ? "Yes"
                  : section7?.investigationByInspector === false
                    ? "No"
                    : section7?.investigationByInspector === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              g) Ceased operating or resigned whilst under investigation by any
              such body or been required to cease operating or resign by any
              regulatory body?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.ceasedOperating === true
                  ? "Yes"
                  : section7?.ceasedOperating === false
                    ? "No"
                    : section7?.ceasedOperating === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              h) Decided, after making an application for any license,
              authorization, registration, notification, membership or any
              permission granted by any such body, not to proceed with it?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.rejectedApplication === true
                  ? "Yes"
                  : section7?.rejectedApplication === false
                    ? "No"
                    : section7?.rejectedApplication === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              i) Been the subject of any civil action related to any regulated
              activity which has resulted in a finding by a court?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.subjectOfCivilAction === true
                  ? "Yes"
                  : section7?.subjectOfCivilAction === false
                    ? "No"
                    : section7?.subjectOfCivilAction === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              j) Provided payment services or distributed or redeemed e-money
              on behalf of a regulated firm or itself under any contractual
              agreement where that agreement was terminated by the regulated
              firm?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.paymentServices === true
                  ? "Yes"
                  : section7?.paymentServices === false
                    ? "No"
                    : section7?.paymentServices === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              k) Been convicted of any criminal offence, censured,
              disciplined or publicly criticized by any inquiry, by the
              Takeover Panel or any government or statutory authority or any
              other regulatory body? (other than as indicated in this group of
              questions)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.convictedOdCriminalOffence === true
                  ? "Yes"
                  : section7?.convictedOdCriminalOffence === false
                    ? "No"
                    : section7?.convictedOdCriminalOffence === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              l) Been on a board of directors in an operating undertaking that
              has not been granted a release from liability?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.boardofDirectorsNotGrantedRelease === true
                  ? "Yes"
                  : section7?.boardofDirectorsNotGrantedRelease === false
                    ? "No"
                    : section7?.boardofDirectorsNotGrantedRelease === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.04.2 Regulatory Matters
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              In relation to activities regulated by the FCA/PRA or any other
              regulator body, have you or any firm at which you hold or have
              held a position of influence at any time during and, within one
              year of your association with the firm ever:
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) Been found to have carried on activities for which
              authorization or registration by the FCA/PRA or any other
              regulatory body isrequired without requisite authorization?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.carriedOnActivitiesWithoutAuthorization === true
                  ? "Yes"
                  : section7?.carriedOnActivitiesWithoutAuthorization === false
                    ? "No"
                    : section7?.carriedOnActivitiesWithoutAuthorization ===
                        "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b) Been investigated for the possible carrying on of activities
              requiring authorization or registration by the FCA/PRA or any
              other regulatory body without the requisite authorization whether
              or not such investigation resulted in a finding against you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.investigatedForCarryingOnActivities === true
                  ? "Yes"
                  : section7?.investigatedForCarryingOnActivities === false
                    ? "No"
                    : section7?.investigatedForCarryingOnActivities === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              c) Been found to have performed a controlled function (or an
              equivalent function requiring approval by the FCA/PRA or any
              other regulatory body) without the requisite approval?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.performedControlledFunctionWithoutApproval === true
                  ? "Yes"
                  : section7?.performedControlledFunctionWithoutApproval ===
                      false
                    ? "No"
                    : section7?.performedControlledFunctionWithoutApproval ===
                        "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              d) Been investigated for the possible performance of a controlled
              function (or an equivalent function requiring approval by the
              FCA/PRA or any other regulatory body) without the requisite
              approval, whether or not such investigation resulted in a finding
              against you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.investigatedForControlledFunction === true
                  ? "Yes"
                  : section7?.investigatedForControlledFunction === false
                    ? "No"
                    : section7?.investigatedForControlledFunction === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              e) Been found to have failed to comply with an obligation under
              the Electronic Money Regulations 2011 or Payment Services
              Regulations 2009 to notify the FCA/PRA of the identity of a
              person acting in a position of influence over its electronic
              money or payment services business?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.failedToComplyWithRegulations === true
                  ? "Yes"
                  : section7?.failedToComplyWithRegulations === false
                    ? "No"
                    : section7?.failedToComplyWithRegulations === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              f) Been the subject of disqualification direction under section
              59 of the Financial Services Act 1986 or a prohibition order
              under section 56 FSMA, or received a warning notice proposing
              that such a direction or order be made, or received a private
              warning?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.subjectOfDisqualificationDirection === true
                  ? "Yes"
                  : section7?.subjectOfDisqualificationDirection === false
                    ? "No"
                    : section7?.subjectOfDisqualificationDirection === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Additional Information (7.04)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.additionalInformation_7_04 || ""}</Text>
            </View>
          </View>
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        7.05 Other Matters
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.05.1 Are you, in the role to which the application relates,
              aware of any business interests, employment obligations, or any
              other circumstance which may conflict with the performance of the
              controlled functions for which approval is now being sought in the
              respect of your control of the firm with your role as controller
              of the applicant firm or your role as controller?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.conflictPerformanceofControlledFunctions === true
                  ? "Yes"
                  : section7?.conflictPerformanceofControlledFunctions === false
                    ? "No"
                    : section7?.conflictPerformanceofControlledFunctions ===
                        "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.05.2
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              For large NDF firms only. Candidates for CF30 only, are not
              required to answer this question.
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Do you have, or know of, any:
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) Qualifying ownership or any other form of substantial
              influence in the firm or group, or any other companies?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.qualifyingOwnership === true
                  ? "Yes"
                  : section7?.qualifyingOwnership === false
                    ? "No"
                    : section7?.qualifyingOwnership === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              If yes, please provide:
            </Text>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              1. Company name and registration number
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.companyName || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              2. Company registration number
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.companyRegistrationNumber || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              3. Nature and scope of the operations
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.natureOfOperations || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              4. The registered office of the company
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.registeredOffice || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              5. Possession in percentage
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.possessionInPercentage || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              a) Close relatives with ownership shares in the firm or group?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.closeRelativesOwnershipShares === true
                  ? "Yes"
                  : section7?.closeRelativesOwnershipShares === false
                    ? "No"
                    : section7?.closeRelativesOwnershipShares === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Name of close relatives with ownership shares
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.nameOfCloseRelativesOwnershipShares || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              b) Close relatives with any other financial relations in the firm
              or group?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.closeRelativesFinancialRelations === true
                  ? "Yes"
                  : section7?.closeRelativesFinancialRelations === false
                    ? "No"
                    : section7?.closeRelativesFinancialRelations === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Name of close relatives with financial relations
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.nameOfCloseRelativesFinancialRelations || ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              c) Any other comments that may give rise to a conflict of
              interest
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.conflictOfInterest === true
                  ? "Yes"
                  : section7?.conflictOfInterest === false
                    ? "No"
                    : section7?.conflictOfInterest === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              7.05.3 Are you aware of any other information relevant to this
              application that we might reasonably expect from you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.otherRelevantInformation === true
                  ? "Yes"
                  : section7?.otherRelevantInformation === false
                    ? "No"
                    : section7?.otherRelevantInformation === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
        </View>
      </View>

      {/* <Text break style={PrintApplicationStyles.subheading}>
        Declarations and Signatures
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        Application to perform controlled functions under the approved persons
        regime to the Financial Conduct Authority
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>
        Declaration of Candidate
      </Text>
      <Text style={PrintApplicationStyles.content}>
        Knowingly or recklessly giving the FCA and/or PRA information which is
        false or misleading in a material particular may be a criminal offence
        (section 398 of the Financial Services and Markets Act 2000).
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Tick here to confirm you have read and understood this
              declaration:
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.confirmedDeclaration === true ? "Yes" : "No"}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Candidate's full name
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section7?.candidateName || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Signature</Text>
            <View style={PrintApplicationStyles.inputBox}>
              {section7?.candidateSignature ? (
                <Image src={section7?.candidateSignature} />
              ) : (
                <Text></Text>
              )}
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Date</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section7?.date
                  ? new Date(section7.date).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })
                  : ""}
              </Text>
            </View>
          </View>
        </View>
      </View>
      <Text style={PrintApplicationStyles.content}>
        Please note we will require your actual signature on this declaration
        and not an e-signature.
      </Text> */}
    </>
  );
};

export default PrintSection7;
